import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function TreePlanting() {
    return (
        <PageWrapper>
            <SEO title={SiteData.treePlanting.metaData.title} description={SiteData.treePlanting.metaData.description}/>
            <PageHeader header={SiteData.treePlanting.h1} subtitle={SiteData.treePlanting.subtitle}/>
            <ServicePageTemplate body={SiteData.treePlanting.body}/>
        </PageWrapper>
    )
}
